import { GetStaticPaths, GetStaticProps } from 'next';
import path from 'path';
import fs from 'fs';
import { BlogPost } from '../../components/blog/post/Post';
import { PostData, getBlogPostData, getAllBlogPostSummaries } from '../../components/blog/utils';

export default BlogPost;

export const getStaticPaths: GetStaticPaths = async () => {
  const posts = getAllBlogPostSummaries();
  
  const paths = posts.map((post) => ({
    params: { slug: post.slug },
  }));

  return { paths, fallback: false };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const slug = params?.slug as string;
  const postData = await getBlogPostData(slug);

  return { props: { postData } };
};